import { Component, OnInit } from '@angular/core';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { NeoComunService } from '../../../comun/services/neoComun.service';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { AlertService } from '../../../services/alert.service';
import { RouterService } from '../../../services/router.service';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { NeoTrazabilidadAuditoriaDTO } from '../../Model/neoTrazabilidadAuditoriaDTO';
import { TrazabilidadAuditoriaService } from '../../Service/trazabilidad-auditoria.service';
import { Constantes } from 'src/app/comun/data/constantes';
declare var $: any;

const datosDetalleSolicitud = {
  idSolicitud: '',
  usuario: null,
};

const datosDevolverSolicitud = {
  idCliente: null,
  idUsuario: null,
  idSolicitud: '',
  idMotivoDevolucionIF: null,
  observacion: '',
};
@Component({
    selector: 'app-devolver-oferta-if',
    templateUrl: './devolver-oferta-if.component.html',
    styleUrls: ['./devolver-oferta-if.component.scss'],
    providers: [NeoComunService, NeoIntermediarioFinancieroService],
    standalone: false
})
export class DevolverOfertaIfComponent implements OnInit {
  public detalleSolcitud: any;
  public user;
  public motivosDevolucion: any[] = [];
  tipoDevolucionId: number = 0;
  observacionDevolver: string = '';
  idTrazabilidad: number = 0;

  isTransaccional: boolean = false;

  constructor(
    public router: Router,
    private readonly _route: ActivatedRoute,
    private readonly _neoComunService: NeoComunService,
    private readonly _userIntermediarioService: UserService,
    private readonly _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private readonly _router: RouterService,
    private readonly _sweetAlert: SweetAlertService,
    private readonly _serviceTrazabilidad: TrazabilidadAuditoriaService
  ) {
    this.user = this._userIntermediarioService.getUser();
    const nav = this.router.getCurrentNavigation();
    this.isTransaccional = nav?.extras.state?.['from'] === Constantes.TRANSACCIONAL;
  }

  ngOnInit(): void {
    this._route.params.subscribe((params: Params) => {
      datosDetalleSolicitud.idSolicitud = params['id'];
      datosDetalleSolicitud.usuario = Number(this.user.idUsuario);
    });

    this._neoComunService.getDetalleSolicitud(datosDetalleSolicitud).subscribe(
      (response) => {
        this.detalleSolcitud = response;
        this.devolucionOferta();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true,
          'No fue posible cargar el detalle de la solicitud'
        );
        this.router.navigate(['intermediario/transaccional/aprobarSolicitudes']);
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );

    this._neoIntermediarioFinancieroService.getMotivosDevolucion().subscribe(
      (response) => {
        if (response['exitoso'] == true) {
          this.motivosDevolucion = response['data'];
        } else {
          this._sweetAlert.errorModal("Error!", true,
            'No fue posible cargar los motivos de devolución'
          );
        }
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true,
          'No fue posible cargar los motivos de devolución'
        );
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );
    datosDevolverSolicitud.idCliente = Number(this.user.idCliente);
    datosDevolverSolicitud.idSolicitud = datosDetalleSolicitud.idSolicitud;
    datosDevolverSolicitud.idUsuario = Number(this.user.idUsuario);
  }

  cancelar() {
    this.cerrarTrazabilidad(this.idTrazabilidad);
    this._router.goBack();
  }

  devolver() {
    if (this.observacionDevolver != '') {
      datosDevolverSolicitud.observacion =
        this.observacionDevolver.toString();
      //if (this.tipoDevolucionId != 0) {
      datosDevolverSolicitud.idMotivoDevolucionIF = null;
      this._neoIntermediarioFinancieroService
        .devolverSolicitud(datosDevolverSolicitud)
        .subscribe(
          (response) => {
            if (response['exitoso']) {
              this._sweetAlert.successModal('¡Éxito!',
                false,
                'La solicitud ha sido devuelta correctamente').then(
                  (result) => {
                    if (result.isConfirmed) {
                      this.router.navigate(['/intermediario/home']);
                    }
                  });
              this.cerrarTrazabilidad(this.idTrazabilidad);
            } else {
              this._sweetAlert.errorModal("Error!", true, 'No fue posible devolver la oferta');
            }
          },
          (error) => {
            this._sweetAlert.errorModal("Error!", true, 'No fue posible devolver la oferta');
          }
        );
      /* } else {
        this._sweetAlert.errorModal("Error!",true,'Seleccione el tipo de devolucion');
      } */
    } else {
      this._sweetAlert.errorModal("Error!", true, 'Ingrese la observación');
    }
  }

  aceptar() {
    $('#aceptarModal').modal('hide');
    this.router.navigate(['/intermediario/home']);
  }

  // Trazabilidad
  devolucionOferta() {
    const body: NeoTrazabilidadAuditoriaDTO = {
      nombreSeccion: this.isTransaccional ? Constantes.TRANSACCIONAL : Constantes.HOME,
      nombrePantalla: Constantes.DEVOLVER_OFERTA_REVISOR,
      idCliente: +this.user.idCliente,
      idUsuario: +this.user.idUsuario,
      idSolicitud: String(datosDevolverSolicitud.idSolicitud),
      perfil: Constantes.PERFIL_ALIADO
    }
    this._serviceTrazabilidad.generarDevolucionOferta(body).subscribe(
      {
        next: resp => {
          this.idTrazabilidad = resp.trazabilidad.idTrazabilidad;
        },
        error: err => {
        }
      });
  }


  cerrarTrazabilidad(idTrazabilidad: number) {
    this._serviceTrazabilidad.cierreTrazabilidad(idTrazabilidad).subscribe({
      next: resp => {
      },
      error: err => {
      }
    });
  }
}
